import AxiosController from "../../../authentication/AxiosController";

// Helper to construct the redirect URI
const getRedirectUri = (lang, country) => { 
  return `https://ecombo.co/${country}/${lang}/panel/outside-integrations/light-funnels?step=2`;
};

// Generates the correct OAuth URL using consistent redirect_uri
export const getAuthUrl = (lang, country) => {
  const clientId = '8lgEgE2NaAyq0iOXDv225';
  const redirectUri = encodeURIComponent(getRedirectUri(lang, country));
  const scope = 'orders,products';
  const state = '1234'; // Should be dynamic in real apps for security

  return `https://app.lightfunnels.com/admin/oauth?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}`;
};

// Handles the OAuth callback logic
export const handleOAuthCallback = async (code, token, lang, country) => {
  if (!code) {
    throw new Error('OAuth code is required');
  }

  try {
    const response = await AxiosController.post(
      `/api/${country}/${lang}/integrations/lightfunnels/oauth/callback`, 
      {
        code,
        redirect_uri: getRedirectUri(lang, country),
        client_id: '8lgEgE2NaAyq0iOXDv225'
      },
      {
        headers: {
          Authorization: `Bearer ${token}`, 
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.data || response.data.error) {
      throw new Error(response.data?.error || 'Failed to complete OAuth process');
    }

    if (response.data.access_token) {
      localStorage.setItem('lightfunnels_token', response.data.access_token); 
    }

    return response.data;
  } catch (error) {
    console.error('OAuth callback error:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Failed to complete OAuth process');
  }
};

// Syncs a single product from Lightfunnels
export const syncSingleProduct = async (token, lang, country, accessToken, productId) => {
  if (!accessToken) {
    throw new Error('Lightfunnels access token is required');
  }

  if (!productId) {
    throw new Error('Product ID is required');
  }

  try {
    const response = await AxiosController.post(
      `/api/${country}/${lang}/integrations/lightfunnels/products`,  
      {
        accessToken,
        productId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error('Single product sync error:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Failed to sync product');
  }
};